module.exports = __webpack_public_path__ + "static/img/nav_about.c98291d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav_about.svg
// module id = OpF0
// module chunks = 1